import { render, staticRenderFns } from "./PreviewGrade.vue?vue&type=template&id=b274aedc&scoped=true"
import script from "./PreviewGrade.vue?vue&type=script&lang=js"
export * from "./PreviewGrade.vue?vue&type=script&lang=js"
import style0 from "./PreviewGrade.vue?vue&type=style&index=0&id=b274aedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b274aedc",
  null
  
)

export default component.exports